var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.editable)?_c('div',[_c('client-only',[_c('quillEditor',{model:{value:(_vm.valueData),callback:function ($$v) {_vm.valueData=$$v},expression:"valueData"}})],1)],1):_c('span',{domProps:{"innerHTML":_vm._s(_vm.valueData)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }